import { all, call, put, takeEvery } from "redux-saga/effects";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/sagasErrorHandler";
import { handleRefreshPublishRequests } from "modules/ConfigCI/services/ConfigCITests/sagas";
import {
    getTestCaseReport,
    mergeTestCaseReportDialog,
    restartTestCase,
    setTestCaseReportDialog
} from "modules/ConfigCI/services/ReportCase/actions";
import {
    getTestCaseReportRequest,
    restartTestCaseReportRequest
} from "modules/ConfigCI/services/ReportCase/api";

//Workers
function* handleGetTestCaseReport ({ payload }) {
    try {
        const { title, id } = payload;
        yield put(setTestCaseReportDialog({ isOpen: true, isLoading: true, title }));
        const { content } = yield call(getTestCaseReportRequest, id);

        yield put(mergeTestCaseReportDialog({ isLoading: false, content }));
    } catch (error) {
        yield put(mergeTestCaseReportDialog({ isLoading: false }));
        getErrorMessage(error);
    }
}

function* handleRestartTestCase ({ payload }) {
    try {
        yield call(restartTestCaseReportRequest, payload);
        yield call(toast.success,"The test has been successfully restarted");
        yield handleRefreshPublishRequests();
    } catch (error) {
        getErrorMessage(error);
    }
}

// Watchers
export function* reportCaseSagas() {
    yield all([
        yield takeEvery(getTestCaseReport, handleGetTestCaseReport),
        yield takeEvery(restartTestCase, handleRestartTestCase)
    ]);
}
